import axios from 'src/api';
import { NotificationManager } from 'react-notifications';
import {
  _addSystemTopup,
  _filterTopupInvoice,
  _getTopupInvoice,
  _addBankTopup
} from 'src/api/TopupRequest';
import { GETTOPUP_SUCCESS } from '../types';

export const getTopup = (filterObj) => {
  return async (dispatch) => {
    try {
      const { data } = await _getTopupInvoice(filterObj);
      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch({ type: GETTOPUP_SUCCESS, payload: data.content });
        // NotificationManager.success("API Code", 'Success');
        return 1;
      }
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const filterTopupInvoice = (obj) => {
  return async (dispatch) => {
    try {
      const { issuerID, fromDate, toDate } = obj;
      const reqObj = {
        data: {
          issuerID,
          fromDate,
          toDate
        }
      };

      const { data } = await _filterTopupInvoice(reqObj);

      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch({ type: GETTOPUP_SUCCESS, payload: data.content });
        // NotificationManager.success(data.success.message, 'Success');
        return 1;
      }
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const addSystemTopup = (obj) => {
  return async (dispatch) => {
    try {
      const reqObj = {
        data: {
          amount: obj.amount,
          reason: obj.reason,
          issuerID: obj.issuerID
        }
      };
      const { data } = await _addSystemTopup(reqObj);
      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch(getTopup());

        NotificationManager.success('System Topup successful', 'Success');
        return 1;
      }
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const addBankTopup = (obj) => {
  return async (dispatch) => {
    try {
      const reqObj = {
        data: {
          amount: obj.amount
        }
      };
      const { data } = await _addBankTopup(reqObj);
      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      }

      return data.content.payLink;
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};
